module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [(_vm.advisor) ? _c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "details-bar column activity-container container-background"
  }, [_c('div', {
    staticClass: "row container activity-container"
  }, [_c('div', {
    staticClass: "row avatar"
  }, [_c('div', {
    staticClass: "ctn-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-avatar",
    style: ({
      backgroundImage: ("url(" + (_vm.advisor.picture) + ")")
    })
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold details-bar-username"
  }, [_vm._v(_vm._s(_vm.advisor.first_name) + " " + _vm._s(_vm.advisor.last_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.advisor.roles[0] && _vm.advisor.roles[0] === "ROLE_ADVISOR" ? "Conseiller" : "Admin") + " chez "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.advisor.office ? _vm.advisor.office : ''))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row infos"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("E-MAIL")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.advisor.email))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("TELEPHONE")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.advisor.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("ADRESSE")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.advisor.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-grey",
    on: {
      "click": function($event) {
        _vm.showAddConseiller = true
      }
    }
  }, [_vm._v("\n              Editer\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle"
  }, [_c('toggle-input', {
    attrs: {
      "value": _vm.advisor.enabled
    },
    on: {
      "change": _vm.updateConseillerStatus
    }
  })], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "take-place column activity-container container-background"
  }, [_c('div', {
    staticClass: "header-table row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Liste des clients de " + _vm._s(_vm.advisor.first_name) + " " + _vm._s(_vm.advisor.last_name) + "\n          ")])]), _vm._v(" "), _c('Table', {
    attrs: {
      "elements": _vm.displayedClients,
      "clickable": true
    },
    on: {
      "statuschange": _vm.updateClientStatus
    }
  }), _vm._v(" "), _c('baseModal', {
    attrs: {
      "data": _vm.advisor,
      "show": _vm.showAddConseiller,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showAddConseiller = false
      }
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f8fb00f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Conseillers/details/Details.vue
// module id = 635
// module chunks = 1